import { PumpShiftEntity, PumpShiftStatusEnum, ShiftEntity } from '../../models'

export const getMinutes = (time: string) => {
  const [hour, minute] = time.split(':')
  return parseInt(minute || '0') + parseInt(hour || '0') * 60
}

export const getHourFormat = (value: Date) => {
  const hour = value.getHours()
  const minutes = value.getMinutes()
  return `${hour > 9 ? hour : '0' + hour}:${
    minutes > 9 ? minutes : '0' + minutes
  }`
}

export const getPumpShiftStatus = (
  pumpShift: PumpShiftEntity,
  shifts: ShiftEntity[],
  currentTime: number
): PumpShiftStatusEnum => {
  const index = shifts.map((item) => item.id).indexOf(pumpShift.shift.id)
  if (index > -1) {
    const startTime =
      pumpShift.createdDate + getMinutes(shifts[index].startTime) * 60000
    const endTime =
      pumpShift.createdDate + getMinutes(shifts[index].endTime) * 60000 + 59999
    if (pumpShift.closedTime) {
      return PumpShiftStatusEnum.CLOSED
    } else if (currentTime < startTime) {
      return PumpShiftStatusEnum.FUTURE
    } else if (startTime <= currentTime) {
      if (currentTime <= endTime) {
        return PumpShiftStatusEnum.WORKING
      } else {
        return PumpShiftStatusEnum.UNCLOSE
      }
    }
  }
  return PumpShiftStatusEnum.WORKING
}

export const getDateFormat = (date: number, hasTime?: boolean) => {
  const dateFormated = new Date(date)
  const time = `${
    dateFormated.getHours() > 9
      ? dateFormated.getHours()
      : `0${dateFormated.getHours()}`
  }:${
    dateFormated.getMinutes() > 9
      ? dateFormated.getMinutes()
      : `0${dateFormated.getMinutes()}`
  }:${
    dateFormated.getSeconds() > 9
      ? dateFormated.getSeconds()
      : `0${dateFormated.getSeconds()}`
  }`
  return (
    (dateFormated.getDate() > 9
      ? dateFormated.getDate()
      : '0' + dateFormated.getDate()) +
    '/' +
    (dateFormated.getMonth() > 8
      ? dateFormated.getMonth() + 1
      : '0' + (dateFormated.getMonth() + 1)) +
    '/' +
    dateFormated.getFullYear() +
    `${hasTime ? `, ${time}` : ''}`
  )
}
